import { render, staticRenderFns } from "./box16.vue?vue&type=template&id=2b6ba5fe&scoped=true&"
import script from "./box16.vue?vue&type=script&lang=js&"
export * from "./box16.vue?vue&type=script&lang=js&"
import style0 from "./box16.vue?vue&type=style&index=0&id=2b6ba5fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6ba5fe",
  null
  
)

export default component.exports